module.exports = __webpack_public_path__ + "static/media/55_000073.f4342e03.jpg";